import { render } from "./MainUsers.vue?vue&type=template&id=b9a100a8&scoped=true"
import script from "./MainUsers.vue?vue&type=script&lang=js"
export * from "./MainUsers.vue?vue&type=script&lang=js"

import "./MainUsers.vue?vue&type=style&index=0&id=b9a100a8&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9a100a8"]])

export default __exports__